document.addEventListener("DOMContentLoaded", () => {

  function initScrollBlur() {
    const slides = document.querySelectorAll('.resource-list__carousel slideshow-slides > *');
    if (!slides.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          slides.forEach(s => s.classList.remove('is-active'));
          entry.target.classList.add('is-active');
        }
      });
    }, {
      threshold: 0.6
    });

    slides.forEach(slide => observer.observe(slide));
  }

  initScrollBlur();
  document.addEventListener("shopify:section:load", initScrollBlur);

});